import React, { PropsWithChildren } from 'react';

import { SVG, SVGIcon } from '../../../components/atoms/SVG';

import { ExtendedInfo } from './partials/ExtendedInfo';

type ExtendedInfoSVG = ExtendedInfo & {
  svgSpriteID: SVGIcon;
};

/**
 * This component generates a Symbol for semantic differentiations with an SVG.
 */
export function ExtendedInfoSVG({ svgSpriteID, ...props }: PropsWithChildren<ExtendedInfoSVG>) {
  return (
    <ExtendedInfo {...props}>
      <SVG svgSpriteId={svgSpriteID} />
    </ExtendedInfo>
  );
}
